import React from 'react'
import { WebhookTrigger } from '~/models'
import { memo } from '~/ui/component'
import { PopupMenuItem } from '~/ui/components'
import { useResourceTranslation } from '~/ui/resources'
import { useFlowPlanner } from '../../FlowPlannerContext'
import { register } from './registry'
import TriggerNodeView from './TriggerNodeView'
import { CommonTriggerNodeViewProps } from './types'

export interface Props extends CommonTriggerNodeViewProps {
  trigger: WebhookTrigger
}

const WebhookTriggerNodeView = memo('WebhookTriggerNodeView', (props: Props) => {

  const {node} = props
  const {planner} = useFlowPlanner()
  const {t} = useResourceTranslation('flow_planner')

  const viewWebhook = React.useCallback(() => {
    planner.viewNodeDetail(node.uuid)
  }, [node.uuid, planner])

  const extraMenuItems = React.useMemo((): PopupMenuItem[] => [{
    icon:     'web',
    caption:  t('triggers.actions.view_webhook'),
    keyHint:  'doubleclick',
    onSelect: viewWebhook,
  }], [t, viewWebhook])

  return (
    <TriggerNodeView
      {...props}
      icon='web'
      extraMenuItems={extraMenuItems}
      onDoubleClick={viewWebhook}
    />
  )
})

register('webhook', WebhookTriggerNodeView)